import axios from "axios";

export default {
  async all(params = []) {
    let result = await axios.get(
      `/api/v1/admin/jobs`,
        {
          params: params
        }
    );
    return result.data.result;
  },
  async getJob(id) {
    let result = await axios.get(
      `/api/v1/admin/jobs/view/${id}`
    );
    return result.data;
  },
  async saveJob(id, payload) {
    let result = await axios.post(
      `/api/v1/admin/jobs/update/${id}`,
      payload
    );
    return result;
  },
  async addJob(payload) {
    let result = await axios.post(
      `/api/v1/admin/jobs/add`,
      payload
    );
    return result;
  },
  async runNow(id, payload) {
    let result = await axios.post(
      `/api/v1/admin/jobs/run/${id}`,
      payload
    );
    return result;
  },
}
